import { render, staticRenderFns } from "./BetslipA.vue?vue&type=template&id=c49cf548&scoped=true"
import script from "./BetslipA.vue?vue&type=script&lang=js"
export * from "./BetslipA.vue?vue&type=script&lang=js"
import style0 from "./BetslipA.vue?vue&type=style&index=0&id=c49cf548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49cf548",
  null
  
)

export default component.exports